import { OK } from 'http-status-codes';
import { debounce, put } from 'redux-saga/effects';

import { ACTION_WAIT_DEBOUNCE_TIME_MS } from '../../constants';
import { safeResolveAsync } from '../../utils';
import { takeLogout } from '../auth';
import * as api from './api';
import { actions, types } from './duck';

export function* getLatestRedemptions({ params, resolve }) {
  try {
    yield put(actions.getLatestRedemptionsRequest());

    const response = yield api.getLatestRedemptions(params);
    if (response.status === OK) {
      yield put(actions.getLatestRedemptionsSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      yield put(actions.getLatestRedemptionsFailure(response.data.detail));
    }
  } catch (error) {
    yield put(actions.getLatestRedemptionsFailure(error.message));
  }
}

export function* clear() {
  yield put(actions.reset());
}

export default function* saga() {
  yield debounce(ACTION_WAIT_DEBOUNCE_TIME_MS, types.GET_LATEST_REDEMPTIONS, getLatestRedemptions);
  yield takeLogout(clear);
}